import React, { useState, useEffect } from 'react';
import { Row, Col, ButtonToolbar, Button } from 'reactstrap';
import { Form, Field } from 'react-final-form';
import { connect } from 'react-redux';
import { withRouter, useHistory } from 'react-router-dom';
import ApiErrorMessage from "@/shared/components/ApiErrorMessage";
import { useDispatch, sendFlashMessage } from "@/shared/components/flash";
import axios from 'axios';
import Select from 'react-select'
import WYSIWYGEditor from '@/shared/components/form/WYSIWYGEditor';

const AddBannerForm = ({ organization }) => {
    const dispatch = useDispatch();
    const history = useHistory();

    const [errors, setErrors] = useState(null);
    const [loading, setLoading] = useState(false);
    const [domains, setDomains] = useState([]);

    useEffect(() => {
        axios
            .get(`/organization/${organization.id}/domain`, {
                params: { minimal: 1 }
            })
            .then(res => {
                setDomains(res.data || []);
            })
            .catch(err => {
                console.error(err);
            });
    }, [organization.id]);

    const onClickCancel = () => {
        history.goBack();
    };

    const domainOptions = domains.map(domain => ({
        value: domain.id,
        label: domain.name
    }));

    const onSubmitAddBanner = values => {
        console.log("onSubmitAddBanner values==>", values);

        setLoading(true);

        axios
            .post(`/organization/${organization.id}/system/banner-status`, values)
            .then(res => {
                if (res.status === 200) {
                    dispatch(
                        sendFlashMessage(
                            'New banner status added successfully',
                            'alert-success'
                        )
                    )
                    history.goBack()
                }
            })
            .catch(error => {
                dispatch(
                    sendFlashMessage(
                        <ApiErrorMessage errors={error.response?.data} />,
                        'alert-danger'
                    )
                );
                setErrors(error.response?.data);
                setLoading(false);
            });
    };

    return (
        <Form
            onSubmit={onSubmitAddBanner}
            validate={validate}
            initialValues={{}}
        >
            {({ handleSubmit, pristine, values }) => (
                <form className="form" onSubmit={handleSubmit}>
                    <Row className="w100">
                        <Col md="6">
                            <h3 className="mb-4">Add Banner</h3>
                        </Col>
                        <Col md="6" className="text-right">
                            <ButtonToolbar className="modal__footer flex justify-content-right w100">
                                <Button outline color="primary" className="mr-3" onClick={onClickCancel}>
                                    Cancel
                                </Button>
                                <Button type="submit" disabled={loading || pristine} color="primary">
                                    Save
                                </Button>
                            </ButtonToolbar>
                        </Col>
                    </Row>

                    {/* Domain Dropdown */}
                    <Row>
                        <Col md="6">
                            <Field name="domain_id">
                                {({ input, meta }) => (
                                    <div className="form__form-group">
                                        <span className="form__form-group-label">Domain</span>
                                        <div className="form__form-group-field">
                                            <Select
                                                options={domainOptions}
                                                isSearchable
                                                isClearable
                                                placeholder="Search domain..."
                                                value={
                                                    domainOptions.find(
                                                        option => option.value === input.value
                                                    ) || null
                                                }
                                                onChange={option =>
                                                    input.onChange(option ? option.value : null)
                                                }
                                                onBlur={input.onBlur}
                                            />

                                            {meta.touched && meta.error && (
                                                <span className="form__form-group-error">
                                                    {meta.error}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </Field>
                        </Col>
                    </Row>

                    {/* Banner Status (WYSIWYG) */}
                    <Row>
                        <Col md="12">
                            <Field name="banner_status">
                                {({ input, meta }) => (
                                    <div className="form__form-group">
                                        <span className="form__form-group-label">Banner Status</span>
                                        <div className="form__form-group-field">
                                            <WYSIWYGEditor
                                                value={input.value}
                                                onChange={input.onChange}
                                            />
                                            {meta.touched && meta.error && (
                                                <span className="form__form-group-error">{meta.error}</span>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </Field>
                        </Col>
                    </Row>
                </form>
            )}
        </Form>
    );
};

const validate = values => {
    let errors = {};
    if (!values.domain_id) {
        errors.domain_id = "Domain is required";
    } else if (!values.banner_status) {
        errors.banner_status = "Banner Status is required";
    }
    return errors;
}

export default withRouter(
    connect(state => ({
        organization: state.organization
    }))(AddBannerForm)
);